/* Copyright 2013 - 2024 Waiterio LLC */
const colorSecondary = '#ffa503'

export default colorSecondary
